module.exports = __webpack_public_path__ + "img/DE05925.76fe031a.png";